import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { type Agent } from "@src/appV2/User/api/useSearchAgents";
import { type Facility } from "@src/appV2/User/api/useSearchFacilities";

import { type SearchResultItem } from "./OmnisearchDialog";

interface OmnisearchResultsListProps {
  agents: Agent[];
  facilities: Facility[];
  selectedIndex: number;
  onSelect: (item: SearchResultItem) => void;
}

export function OmnisearchResultsList(props: OmnisearchResultsListProps) {
  const { agents, facilities, selectedIndex, onSelect } = props;

  return (
    <List sx={{ py: 0 }}>
      {agents.length > 0 && (
        <>
          <ListItem sx={{ py: 0.5, px: 2 }}>
            <Text
              color="text.secondary"
              sx={{ fontWeight: 600, textTransform: "uppercase" }}
              variant="caption"
            >
              Professionals
            </Text>
          </ListItem>
          {agents.map((agent, index) => (
            <ListItemButton
              key={agent.userId}
              selected={selectedIndex === index}
              sx={{
                py: 1,
                px: 2,
                "&.Mui-selected": {
                  backgroundColor: "action.selected",
                },
              }}
              onClick={() => {
                onSelect({ type: "agent", data: agent });
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <PersonIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={agent.name}
                primaryTypographyProps={{ fontWeight: 500 }}
                secondary={agent.email}
                secondaryTypographyProps={{ variant: "caption" }}
              />
            </ListItemButton>
          ))}
        </>
      )}

      {facilities.length > 0 && (
        <>
          <ListItem sx={{ py: 0.5, px: 2, mt: agents.length > 0 ? 1 : 0 }}>
            <Text
              color="text.secondary"
              sx={{ fontWeight: 600, textTransform: "uppercase" }}
              variant="caption"
            >
              Workplaces
            </Text>
          </ListItem>
          {facilities.map((facility, index) => {
            const resultIndex = agents.length + index;

            return (
              <ListItemButton
                key={facility.userId}
                selected={selectedIndex === resultIndex}
                sx={{
                  py: 1,
                  px: 2,
                  "&.Mui-selected": {
                    backgroundColor: "action.selected",
                  },
                }}
                onClick={() => {
                  onSelect({ type: "facility", data: facility });
                }}
              >
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <BusinessIcon color="secondary" />
                </ListItemIcon>
                <ListItemText
                  primary={facility.name}
                  primaryTypographyProps={{ fontWeight: 500 }}
                  secondary={`${facility.type} • ${facility.status}`}
                  secondaryTypographyProps={{ variant: "caption" }}
                />
              </ListItemButton>
            );
          })}
        </>
      )}
    </List>
  );
}
